module.exports = __webpack_public_path__ + "img/phluently.93634cdc.jpeg";